import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import * as CliAppInvitee from 'app/entities/CliAppInvitee';
import * as LegacyActions from 'app/developer-v3/legacy/Actions';
import LoadingBlockOrComponent from 'app/common/components/LoadingBlockOrComponent';
import hocify from 'app/common/components/hocify';
import { NEW_ENTITY_IDS } from 'app/developer-v3/constants';
import { selectAppId, selectInviteUrl } from 'app/developer-v3/store/selectors';

import SharingPage from './SharingPage';

const mapStateToProps = state => {
  const appId = selectAppId(state);

  const newInvitee = CliAppInvitee.selectors.all.entity(
    NEW_ENTITY_IDS.invitee,
    state
  );
  const newInviteeErrorStatus = CliAppInvitee.selectors.statusMessage(
    newInvitee
  );
  const newInviteeIsSaving = CliAppInvitee.selectors.isSaving(newInvitee);

  return {
    appId,
    invitees: CliAppInvitee.selectors.appInvitees(state),
    fieldErrors: {
      email: newInviteeErrorStatus,
    },
    inviteUrl: selectInviteUrl(state),
    isLoading:
      CliApp.selectors.all.isLoading(state) ||
      CliAppInvitee.selectors.all.isLoading(state),
    isSaving: newInviteeIsSaving,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    onLoad() {
      dispatch(LegacyActions.loadCliInvitees());
      dispatch(CliApp.actions.loadEntity(null, props.params.id));
    },
    onAddInvitee(appId, email, appVersion) {
      dispatch(LegacyActions.addCliInvitee(appId, email, appVersion));
    },
    onDeleteInvitee(appId, invitee) {
      dispatch(LegacyActions.deleteCliInvitee(appId, invitee));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(hocify(LoadingBlockOrComponent)(SharingPage));
